import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  capitalizeString,
  errorMessage,
  successMessage,
} from "../CommonFunctions";

import { post, get } from "../../../helpers/api_helper";
import {
  POST_AdvanceReceiptInsert,
  POST_AdvanceReceiptUpdate,
  POST_GetAdvanceReceiptDetailByID,
  POST_GetBranchBankDDLList,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLListAJAX,
  POST_GetPaymentModeList,
} from "../../../helpers/url_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomInputAutoSuggest from "../../../CustomControls/CustomInputAutoSuggest";
import moment from "moment";

const AddAdvanceReceipt = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [contactPersonOptions, setContactPersonOptions] = useState([]);
  const [receivableBankOptions, setReceivableBankOptions] = useState([]);
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    // ReceiptNo: Yup.string().trim().required("Receipt No  is required field"),
    ReceiptDate: Yup.string()
      .trim()
      .required("Receipt Date  is required field"),
    CustomerIDEncrypted: Yup.string()
      .trim()
      .required("Customer  is required field"),
    AmountReceived: Yup.string()
      .trim()
      .required("Amount Received  is required field"),
    PaymentModeID: Yup.string()
      .trim()
      .required("Payment Mode  is required field"),

    CashReceivedBy: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 1)
          return Yup.string().required("Received By is required field");
        return schema;
      },
    ),
    ChequeNo: Yup.string().when("PaymentModeID", ([PaymentModeID], schema) => {
      if (PaymentModeID == 2)
        return Yup.string().required("Cheque No is required field");
      return schema;
    }),
    ChequeDate: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 2)
          return Yup.string().required("Cheque Date is required field");
        return schema;
      },
    ),
    ChequeBankName: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 2)
          return Yup.string().required("Bank Name is required field");
        return schema;
      },
    ),

    OtherDetail: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 4)
          return Yup.string().required("Other Detail is required field");
        return schema;
      },
    ),
    OtherName: Yup.string().when("PaymentModeID", ([PaymentModeID], schema) => {
      if (PaymentModeID == 4)
        return Yup.string().required("Other Name is required field");
      return schema;
    }),
    OtherMobileNo: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 4)
          return Yup.string().required("Mobile No is required field");
        return schema;
      },
    ),

    TranNo: Yup.string().when("PaymentModeID", ([PaymentModeID], schema) => {
      if (PaymentModeID == 5)
        return Yup.string().required("Tran No is required field");
      return schema;
    }),
    TranDate: Yup.string().when("PaymentModeID", ([PaymentModeID], schema) => {
      if (PaymentModeID == 5)
        return Yup.string().required("Tran Date is required field");
      return schema;
    }),
    CardBankName: Yup.string().when(
      "PaymentModeID",
      ([PaymentModeID], schema) => {
        if (PaymentModeID == 5)
          return Yup.string().required("Bank Name is required field");
        return schema;
      },
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      AdvanceReceiptIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ReceiptNo: "",
      ReceiptDate: "",
      CustomerIDEncrypted: "",
      ContactPerson: "",
      MobileNo: "",
      ReceivableBankIDEncrypted: "",
      AmountReceived: "",
      PaymentModeID: "",
      CashReceivedBy: "",
      ChequeNo: "",
      ChequeDate: "",
      ChequeBankName: "",
      OtherDetail: "",
      OtherName: "",
      OtherMobileNo: "",
      TranNo: "",
      TranDate: "",
      CardBankName: "",
      Remarks: "",
      SettledAmount: "",
      AvailableAmount: "",
      CustomerName: "",
      ContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      AdvanceReceiptIDEncrypted,
      CustomerIDEncrypted,
      PaymentModeID,
      CustomerName,
      ContactPersonID,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    let MobileNumbers = values?.MobileNo?.trim();
    let OtherMobileNo = values?.OtherMobileNo?.trim();

    // if (values?.MobileNo) {
    //   const isValidFormat = /^(\d{10})(\d{10})*$/.test(MobileNumbers);

    //   if (!isValidFormat) {
    //     errorMessage("Please enter valid mobile numbers.");
    //     return;
    //   }
    // }

    if (values?.OtherMobileNo) {
      const isValidFormatOtherMobileNo = /^(\d{10})(\d{10})*$/.test(
        OtherMobileNo,
      );

      if (!isValidFormatOtherMobileNo) {
        errorMessage("Please enter valid other mobile numbers.");
        return;
      }
    }

    setIsLoading(true);

    let payload = {
      ...values,
      AdvanceReceiptIDEncrypted: values?.AdvanceReceiptIDEncrypted,
      CustomerIDEncrypted: values?.CustomerIDEncrypted,
      ReceivableBankIDEncrypted: values?.ReceivableBankIDEncrypted,
      ReceiptDate: values?.ReceiptDate
        ? moment(values?.ReceiptDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",

      ContactPerson: values?.ContactPerson.trim(),
      ContactPersonID: values?.ContactPersonID ? values?.ContactPersonID : "0",
      MobileNo: values?.MobileNo.trim(),
      AmountReceived: values?.AmountReceived
        ? values?.AmountReceived.toString()
        : "0.00",
      ChequeDate: values?.ChequeDate
        ? moment(values?.ChequeDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      TranDate: values?.TranDate
        ? moment(values?.TranDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",

      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      PrimaryIdParam ? POST_AdvanceReceiptUpdate : POST_AdvanceReceiptInsert,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/advance-receipt");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getReceivableBank();
    getPaymentMode();
    if (PrimaryIdParam) {
      getAdvanceReceiptDetails();
    }
  }, []);

  const getAdvanceReceiptDetails = async () => {
    setIsLoading(true);
    await post(POST_GetAdvanceReceiptDetailByID, {
      AdvanceReceiptIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            AdvanceReceiptIDEncrypted: response?.AdvanceReceiptIDEncrypted,
            CustomerIDEncrypted: response?.CustomerIDEncrypted,
            ReceivableBankIDEncrypted: response?.ReceivableBankIDEncrypted,
            ContactPersonID: response?.ContactPersonID,
            ReceiptDate: response?.ReceiptDate
              ? new Date(response?.ReceiptDate)
              : "",
            ChequeDate: response?.ChequeDate
              ? new Date(response?.ChequeDate)
              : "",
            TranDate: response?.TranDate ? new Date(response?.TranDate) : "",
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getContactPersonDDL(CustomerIDEncrypted);
    } else {
      setContactPersonOptions([]);
      formik.setFieldValue("ContactPerson", "");
      formik.setFieldValue("MobileNo", "");
      formik.setFieldValue("ContactPersonID", "");
    }
  }, [CustomerIDEncrypted]);

  const getContactPersonDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              // label: item.ContactPerson,
              // value: item.CustomerContactPersonIDEncrypted,
              name: item?.ContactPerson,
              MobileNo: item?.MobileNo,
              EmailID: item?.EmailID,
              Designation: item?.Designation,
              ContactPerson: item?.ContactPerson,
              ContactPersonID: item?.ContactPersonID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const getReceivableBank = async () => {
    setIsLoading(true);
    await post(POST_GetBranchBankDDLList, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReceivableBankOptions(
            response?.List?.map((item) => ({
              label: item.BankName,
              value: item.BranchBankIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const getPaymentMode = async () => {
    setIsLoading(true);
    await get(POST_GetPaymentModeList)
      .then((response) => {
        if (response?.IsSuccess) {
          setPaymentModeOptions(
            response?.List?.map((item) => ({
              label: item.PaymentMode,
              value: item.PaymentModeID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Advance Receipt
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  {AdvanceReceiptIDEncrypted ? (
                    <Col lg={3}>
                      <Field
                        label="Receipt No"
                        name="ReceiptNo"
                        placeholder={"Enter Receipt No"}
                        component={CustomInput}
                        disabled={true}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col lg={3}>
                    <Field
                      label="Receipt Date"
                      name="ReceiptDate"
                      placeholder={"Select Receipt Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        maxDate: new Date(),
                      }}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    {!AdvanceReceiptIDEncrypted ? (
                      <Field
                        label="Customer"
                        name="CustomerIDEncrypted"
                        placeholder={"Select Customer"}
                        loadOptionsFn={loadOptionsCutomer}
                        component={CustomSelectAsync}
                        title={CustomerName}
                        labelFieldName="CustomerName"
                        required
                      />
                    ) : (
                      <Field
                        label="Customer"
                        name="CustomerName"
                        component={CustomInput}
                        required
                        disabled={true}
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Contact Person"
                      name="ContactPerson"
                      placeholder="Contact Person"
                      component={CustomInputAutoSuggest}
                      options={contactPersonOptions}
                      onChange={(e) => {
                        // console.log(e);
                        // console.log(e?.ContactPerson ?? e);
                        formik.setFieldValue(
                          "ContactPerson",
                          capitalizeString(e?.ContactPerson ?? e),
                        );

                        formik.setFieldValue("MobileNo", e?.MobileNo ?? "");
                        formik.setFieldValue(
                          "ContactPersonID",
                          e?.ContactPersonID ?? "",
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Mobile No"
                      name="MobileNo"
                      placeholder={"Enter Mobile No like 1234567890"}
                      component={CustomInput}
                      maxLength={15}
                    />
                  </Col>

                  <Col lg={3}>
                    <Field
                      label="Receivable Bank"
                      name="ReceivableBankIDEncrypted"
                      placeholder={"Select Bank"}
                      options={receivableBankOptions}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      type="number"
                      label="Amount Received"
                      name="AmountReceived"
                      placeholder={"Enter Amount"}
                      component={CustomInput}
                      maxLength={10}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Payment Mode"
                      name="PaymentModeID"
                      placeholder={"Select Payment Mode"}
                      options={paymentModeOptions}
                      component={CustomSelect}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Remarks"
                      name="Remarks"
                      placeholder={"Enter Remarks"}
                      component={CustomTextArea}
                      rows={5}
                      maxLength={500}
                    />
                  </Col>
                  {PaymentModeID == 1 ? (
                    <Col lg={3}>
                      <Field
                        label="Received By"
                        name="CashReceivedBy"
                        placeholder={"Enter Received By"}
                        component={CustomInput}
                        maxLength={100}
                        required
                      />
                    </Col>
                  ) : PaymentModeID == 2 ? (
                    <>
                      <Col lg={3}>
                        <Field
                          label="Cheque No"
                          name="ChequeNo"
                          placeholder={"Enter Cheque No"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Cheque Date"
                          name="ChequeDate"
                          placeholder={"Select Cheque Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                          }}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Bank Name"
                          name="ChequeBankName"
                          placeholder={"Enter Bank Name"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>
                    </>
                  ) : PaymentModeID == 4 ? (
                    <>
                      <Col lg={3}>
                        <Field
                          label="Other Detail"
                          name="OtherDetail"
                          placeholder={"Enter OtherDetail"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>

                      <Col lg={3}>
                        <Field
                          label="Other Name"
                          name="OtherName"
                          placeholder={"Enter Other Name"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Mobile No"
                          name="OtherMobileNo"
                          placeholder={"Enter Mobile No like 1234567890"}
                          component={CustomInput}
                          maxLength={15}
                          required
                        />
                      </Col>
                    </>
                  ) : PaymentModeID == 5 ? (
                    <>
                      <Col lg={3}>
                        <Field
                          label="Tran No"
                          name="TranNo"
                          placeholder={"Enter Tran No"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Tran Date"
                          name="TranDate"
                          placeholder={"Select Tran Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                          }}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Bank Name"
                          name="CardBankName"
                          placeholder={"Enter Bank Name"}
                          component={CustomInput}
                          maxLength={100}
                          required
                        />
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddAdvanceReceipt;
